import { EPersona } from '@sharedInterfaces/EPersona';

// Action Types
export enum EPersonasAction {
    SET_PERSONAS = 'SET_PERSONAS',
}

// Action Interfaces
interface SetPersonasAction {
    type: EPersonasAction.SET_PERSONAS;
    payload: EPersona[];
}

// Union Type for all actions
export type PersonasAction = SetPersonasAction;

// Initial State
export const initialPersonasState: EPersona[] = [EPersona.Employee];

// Reducer
export function personasReducer(state: EPersona[] = initialPersonasState, action: PersonasAction): EPersona[] {
    switch (action.type) {
        case EPersonasAction.SET_PERSONAS:
            return action.payload;
        default:
            return state;
    }
}

// Action Creators
export const setPersonas = (personas: EPersona[]): SetPersonasAction => ({
    type: EPersonasAction.SET_PERSONAS,
    payload: personas,
});

// Selectors
export const selectPersonas = (state: { personas: EPersona[] }): EPersona[] => state.personas;
export const selectIsAdmin = (state: { personas: EPersona[] }): boolean => state.personas.includes(EPersona.Admin);
export const selectIsFK = (state: { personas: EPersona[] }): boolean => state.personas.includes(EPersona.FK);
export const selectIsEmployee = (state: { personas: EPersona[] }): boolean =>
    state.personas.includes(EPersona.Employee);
